// extracted by mini-css-extract-plugin
module.exports = {"body":"Layout-module--body--2xP6A","content":"Layout-module--content--nwbxQ"};